<template>
   <div>
    <Navbar />
    <div class="comapny-detail-layout">
        <CompanySidebar :company="company"/>
        <div class="company-detail-layout-content">
          <div class="company-name-header">
            <div class="company-name-detail">
                <img v-if="companyDetails.logo" :src="companyDetails.logo" alt="company-icon-small">
                <img v-else src="@/assets/company-icon-small.svg" alt="">
                <p>{{ companyDetails.company_name }}</p>
            </div>
            <router-link :to="{ name: 'Company'}">View Dashboard</router-link>
          </div>
          <div class="switch-buttons">
            <button @click="companyActive = true; userActive = false; faciltyActive = false" :class="{ company: companyActive }">Company</button>
            <button @click="userActiveShow(); changeUserState();" :class="{ user: userActive }">Users</button >
            <button @click="facilityActiveShow(); changeFacilityState();" :class="{ facility: faciltyActive }">Facilities</button>
            <button @click="changeDeviceState();" :class="{ device: deviceActive }">Devices</button>
          </div>

          <!-- //////// -->
          <div class="company-details" v-if="companyActive">
              <div class="company-name">
                <div>
                    <h4>Company name</h4>
                    <p>- {{ companyDetails.company_name }}</p>
                </div>
                <button>
                    Edit
                </button>
              </div>
              <div class="company-address">
                  <h4>Company address</h4>
                  <p>- {{ companyDetails.address }}</p>
              </div>
              <div class="subscription-type">
                  <h4>Subscription type</h4>
                  <p>- {{ companyDetails.subscription_type }}</p>
              </div>
              <div class="subscription-status">
                  <h4>Subscription Status</h4>
                  <p>
                      - {{ companyDetails.subscription_status.charAt(0).toUpperCase() + companyDetails.subscription_status.slice(1) }}
                  </p>
              </div>
              <div class="company-email">
                  <h4>Company email</h4>
                  <p>- {{ companyDetails.email }}</p>
              </div>
          </div>

          <!-- /////// -->
          <div v-if="userActive" class="user-device-table">
            <h2>Users</h2>
                <b-table :data="users">
                <b-table-column field="name" label="Username" v-slot="props">
                    {{ props.row.name}}
                </b-table-column>
                <b-table-column field="address" label="Fullname" v-slot="props">
                    {{ props.row.name }}
                </b-table-column>
                <b-table-column field="role" label="Address" v-slot="props">
                    {{ props.row.address }}
                </b-table-column>
                <b-table-column field="role" label="Role" v-slot="props">
                    {{ props.row.role.charAt(0).toUpperCase() + props.row.role.slice(1) }}
                </b-table-column>
                <b-table-column field="edit" label="Actions">
                </b-table-column>
            </b-table>
          </div>

          <!-- //// -->
          <div v-if="faciltyActive">
              <div class="facility-heading">
                  <h2>Filling Station</h2>
                  <button>Add New</button>
              </div>
              <div class="facilities-display">
                  <router-link :to="{ path: '/admin/facility/' + facility.id }" class="border-facility" v-for="facility in facilities" :key="facility.id">
                      {{ facility.facility_name }}
                  </router-link>
              </div>
          </div>

          <!-- //// -->
          <div v-if="deviceActive" class="user-device-table">
              <h2>All Device</h2>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/NavBar.vue';
import CompanySidebar from '@/components/CompanySidebar.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CompanyDetails',
  components: {
    Navbar,
    CompanySidebar
  },
  data() {
    return {
      companyActive: false,
      userActive: false,
      faciltyActive: false,
      deviceActive: false
    };
  },
  async mounted() {
    await this.fetchCompany();
    await this.fetchCompanyDetails(this.$route.params.id);
    this.companyActive = true;
  },
  async created() {
    await this.userActiveShow();
    await this.facilityActiveShow();
    // await this.deviceActiveShow();
  },
  watch: {
    $route() {
      this.fetchCompanyDetails(this.$route.params.id);
    }
  },
  computed: {
    ...mapGetters(['getLoggedUser']),
    ...mapGetters('apps', {
      company: 'getCompany',
      companyDetails: 'getCompanyDetails',
      users: 'getUsers',
      facilities: 'getFacilities',
      //   devices: 'getDevices',
      tank: 'getTankDetails'
    })
  },
  methods: {
    ...mapActions('apps', [
      'fetchCompanyDetails',
      'fetchCompany',
      'fetchUsers',
      'fetchFacilities'
    //   'fetchDevices'
    ]),
    async userActiveShow() {
      const tank = {
        company_id: this.companyDetails.id
      };
      await this.fetchUsers(tank);
    },
    // async deviceActiveShow() {
    //   const tank = {
    //     company_id: this.companyDetails.id,
    //     facility_id: this.facilities[0].id,
    //     tank_id: this.tank[0].id
    //   };
    //   await this.fetchDevices(tank);
    // },
    async facilityActiveShow() {
      const tank = {
        id: this.companyDetails.id
      };
      await this.fetchFacilities(tank);
    },
    changeUserState() {
      this.userActive = true;
      this.companyActive = false;
      this.faciltyActive = false;
      this.deviceActive = false;
    },
    changeFacilityState() {
      this.faciltyActive = true;
      this.userActive = false;
      this.companyActive = false;
      this.deviceActive = false;
    },
    changeDeviceState() {
      this.deviceActive = true;
      this.userActive = false;
      this.companyActive = false;
      this.faciltyActive = false;
    }
  }
};
</script>

<style scoped lang="scss">
.company-detail-layout-content {
    background: #FFFFFF;
    border: 0.5px solid #C4C4C4;
    padding: 40px;
    margin-right: 80px;
}
.comapny-detail-layout {
    margin-top: 100px;
    display: grid;
    grid-template-columns: 0.5fr 2fr;
}
.company-name-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.company-name-detail {
    display: flex;
    align-items: center;
    img {
      width: 50px;
    }
    p {
      margin-left: 15px;
      font-style: normal;
      font-weight: normal;
      font-size: 22px;
      line-height: 24px;
      letter-spacing: -0.4px;
      color: #454141;
    }
}
.switch-buttons {
    margin-top: 25px;
    button {
        background: #DDDDDD;
        width: 120px;
        padding: 10px 0;
        border: 1px solid #DDDDDD;
        cursor: pointer;
    }
    button:nth-child(2),
    button:nth-child(3),
    button:nth-child(4) {
        margin-left: 20px;
    }
    .company, .user, .facility, .device {
        background: #3887F6;
        color: #FFFFFF;
    }
}
.company-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
        background: none;
        border: none;
        color: #3887F6;
        text-decoration: underline;
    }
}
.company-details {
    div {
        margin-top: 33px;
        h4 {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 18px;
            color: #000000;
        }
        p {
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #736F6F;
            margin-top: 10px;
        }
    }
}
.user-device-table {
    margin-top: 15px;
    padding-top: 20px;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
    h2 {
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        color: #736F6F;
        padding-left: 15px;
    }
}
.facility-heading {
    display: flex;
    align-items: center;
    margin-top: 30px;
    h2 {
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 24px;
        color: #000000;
    }
    button {
        background: none;
        border: none;
        text-decoration: underline;
        color: #3887F6;
        margin-left: 30px;
    }
}
.facilities-display {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    margin-top: 30px;
    .border-facility {
        background: #FFFFFF;
        border: 2px solid #C5C5C6;
        width: 142px;
        height: 120.01px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
